import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { ComponentStoreFactory } from '../../../../shared/store/common/component-store.factory';


interface State {
}

const defaultState: State = {};

@Injectable()
export class PersonContactUpsertDialogStore extends ComponentStoreFactory<State> {

    constructor() {
        super(defaultState, inject(Store));
    }

}
